import { Gem, Shield, Globe, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-amber-500/15 bg-[#08080C] pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl gold-btn grid place-items-center">
                <Gem className="w-5 h-5 text-black" />
              </div>
              <div className="font-display font-extrabold text-lg">Money<span className="gold-text">MoonX</span></div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Trusted global wealth platform. Building wealth, securing futures across forex & crypto markets.
            </p>
          </div>
          <div>
            <h4 className="font-display font-semibold text-amber-400 mb-4 text-sm uppercase tracking-wider">Markets</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="#crypto" className="hover:text-amber-300">Crypto Market</a></li>
              <li><a href="#forex" className="hover:text-amber-300">Forex Market</a></li>
              <li><a href="#trends" className="hover:text-amber-300">Trends & Trades</a></li>
              <li><a href="#about" className="hover:text-amber-300">Who We Are</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-semibold text-amber-400 mb-4 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="/register" className="hover:text-amber-300">Get Started</a></li>
              <li><a href="/login" className="hover:text-amber-300">Investor Login</a></li>
              <li><a href="#about" className="hover:text-amber-300">About Us</a></li>
              <li><a href="#trends" className="hover:text-amber-300">Market Insights</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-semibold text-amber-400 mb-4 text-sm uppercase tracking-wider">Assurance</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-2"><Shield className="w-4 h-4 text-emerald-400" /> Secure Blockchain</li>
              <li className="flex items-center gap-2"><Globe className="w-4 h-4 text-sky-400" /> 50+ Countries</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-amber-400" /> 24/7 Support</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-amber-500/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <p>© 2026 MoneyMoonX. All rights reserved.</p>
          <p className="font-mono-fin">USDT BEP20 · Smart Choice. Brighter Future.</p>
        </div>
      </div>
    </footer>
  );
}
